import { EnvType } from "../services";
import ApiClient from "../api-client";
import IOrderApiClient from "../Order/order-api-client";
import OrderApiClient from "../Order/order-api-client";
import { GetBroadcastersListResponse } from "../Types/get-broadcasters-list-response";
import { GetDeliveryProductsListResponse } from "../Types/get-delivery-products-list-response";
import { DbDeliveryProductInfos } from "../Types/db-delivery-product-infos";
import { GenericResponseStd } from "../Types/generic-response-std";
import { GetCustomersListResponse } from "../Types/get-customers-list-response";
import { DbCustomerInfos } from "../Types/db-customer-infos";
import { GetOrdersListResponse } from "../Types/get-orders-list-response";
import { GetOrderResponse } from "../Types/get-order-response";
import { GetOrderItemsForOrderIdResponse } from "../Types/get-order-items-for-order-id-response";
import { SetOrderFollowersRequest } from "../Types/set-order-followers-request";
import { GetItemsCountersResponse } from "../Types/get-items-counters-response";
import { GetItemsListResponse } from "../Types/get-items-list-response";
import { AclWorkflowAccessLevel } from "../Types/acl-workflow-access-level";
import { GetOrderItemResponse } from "../Types/get-order-item-response";
import { GetOrderItemStackResponse } from "../Types/get-order-item-stack-response";
import { GetOrderItemManualTasksResponse } from "../Types/get-order-item-manual-tasks-response";
import { ApplyManualChangesOnItemByIdRequest } from "../Types/apply-manual-changes-on-item-by-id-request";
import { ApplyManualChangesOnItemByIdsRequest } from "../Types/apply-manual-changes-on-item-by-ids-request";
import { ApplyManualChangesOnItemByIdsResponse } from "../Types/apply-manual-changes-on-item-by-ids-response";
import { SetOrderItemFollowersRequest } from "../Types/set-order-item-followers-request";
import { GetOrderItemIssueTypesResponse } from "../Types/get-order-item-issue-types-response";
import { GetOrderItemIssuesResponse } from "../Types/get-order-item-issues-response";
import { GetMissingAssetsByTitleId } from "../Types/get-missing-assets-by-title-id";
import { GetBenefitsTypesResponse } from "../Types/get-benefits-types-response";
import { CreateInternalOrderRequest } from "../Types/create-internal-order-request";
import { GetMetadataFieldsListResponse } from "../Types/get-metadata-fields-list-response";
import { GetCurrenciesResponse } from "../Types/get-currencies-response";
import { GetPriceRulesResponse } from "../Types/get-price-rules-response";
import { DbOrderPriceRuleInfos } from "../Types/db-order-price-rule-infos";
import { MatchPriceRuleRequest } from "../Types/match-price-rule-request";
import { ContentResult } from "../Types/content-result";
import { AdminTitleOrderRow } from "../../../Pages/admin/Inventory/InventoryTitleSingle/TitleSingleOrders/title-single-orders";
import { GetCustomerResponse } from "../Types/get-customer-response";
import { CreateQuoteOrderRequest } from "../Types/create-quote-order-request";
import { GetWatermarksResponse } from "../Types/get-watermarks-response";
import { GetWatermarkResponse } from "../Types/get-watermark-response";
import { ResendTransferEmailRequest } from "../Types/resend-transfer-email-request";
import { CreateSimpleOrderRequest } from "../Types/create-simple-order-request";

export default class OrderService {
  orderApiClient: IOrderApiClient;

  constructor(envType: EnvType) {
    this.orderApiClient = new OrderApiClient(new ApiClient(envType), envType);
  }
  async GetBroadcastersList(): Promise<GetBroadcastersListResponse> {
    return await this.orderApiClient.GetBroadcastersList();
  }
  async GetBroadcastersBundlemakerList(): Promise<GetBroadcastersListResponse> {
    return await this.orderApiClient.GetBroadcastersBundlemakerList();
  }

  async DownloadBroadcasterDocuments(broadcasterId: number): Promise<any> {
    const [fileData, headers] = await this.orderApiClient.DownloadBroadcasterDocuments(broadcasterId);

    if (!fileData || fileData.length === 0) return false;
    let fileName = `Broadcaster_${broadcasterId}_documents.zip`;

    const blob = new Blob([fileData], { type: "application/zip" });
    const url = window.URL.createObjectURL(blob);

    const linkElement = document.createElement("a");
    linkElement.href = url;
    linkElement.download = fileName;

    const clickEvent = new MouseEvent("click", { view: window, bubbles: true, cancelable: false });
    linkElement.dispatchEvent(clickEvent);

    window.URL.revokeObjectURL(url);

    return true;
  }
  async GetDeliveryProductsList(): Promise<GetDeliveryProductsListResponse> {
    return await this.orderApiClient.GetDeliveryProductsList();
  }
  async GetAllDeliveryProductsList(): Promise<GetDeliveryProductsListResponse> {
    return await this.orderApiClient.GetAllDeliveryProductsList();
  }
  async UpdateProduct(request: DbDeliveryProductInfos): Promise<GenericResponseStd> {
    return await this.orderApiClient.UpdateProduct(request);
  }
  async GetCustomersList(): Promise<GetCustomersListResponse> {
    return await this.orderApiClient.GetCustomersList();
  }
  async GetCustomerById(id: number): Promise<GetCustomerResponse> {
    return await this.orderApiClient.GetCustomerById(id);
  }
  async CreateCustomer(request: DbCustomerInfos): Promise<GenericResponseStd> {
    return await this.orderApiClient.CreateCustomer(request);
  }
  async EditCustomer(request: DbCustomerInfos): Promise<GenericResponseStd> {
    return await this.orderApiClient.EditCustomer(request);
  }
  async DeleteCustomer(id: number): Promise<GenericResponseStd> {
    return await this.orderApiClient.DeleteCustomer(id);
  }
  async GetCustomersByConnectedAccount(): Promise<GetCustomersListResponse> {
    return await this.orderApiClient.GetCustomersByConnectedAccount();
  }
  async SyncCustomerByErp(): Promise<GenericResponseStd> {
    return await this.orderApiClient.SyncCustomerByErp();
  }
  async GetOrdersList(pageNb: number, pageSize: number): Promise<GetOrdersListResponse> {
    return await this.orderApiClient.GetOrdersList(pageNb, pageSize);
  }
  async GetOrdersListByDate(startDateAsString: string, endDateAsString: string): Promise<GetOrdersListResponse> {
    return await this.orderApiClient.GetOrdersListByDate(startDateAsString, endDateAsString);
  }
  async GetOrderById(orderId: number): Promise<GetOrderResponse> {
    return await this.orderApiClient.GetOrderById(orderId);
  }
  async PlayOrderById(orderId: number): Promise<GenericResponseStd> {
    return await this.orderApiClient.PlayOrderById(orderId);
  }
  async CancelOrderById(orderId: number): Promise<GenericResponseStd> {
    return await this.orderApiClient.CancelOrderById(orderId);
  }
  async GetOrderItemsForOrderId(orderId: number, accessKey: string): Promise<GetOrderItemsForOrderIdResponse> {
    return await this.orderApiClient.GetOrderItemsForOrderId(orderId, accessKey);
  }
  async SetOrderFollowers(request: SetOrderFollowersRequest): Promise<GenericResponseStd> {
    return await this.orderApiClient.SetOrderFollowers(request);
  }
  async GetOrdersByCustomerId(customerId: number): Promise<GetOrderItemsForOrderIdResponse> {
    return await this.orderApiClient.GetOrdersByCustomerId(customerId);
  }
  async DownloadOrdersItemsListAsCSV(startDateAsString: string, endDateAsString: string): Promise<GenericResponseStd> {
    return await this.orderApiClient.DownloadOrdersItemsListAsCSV(startDateAsString, endDateAsString);
  }
  async GetItemsCounters(): Promise<GetItemsCountersResponse> {
    return await this.orderApiClient.GetItemsCounters();
  }
  async GetItemsList(pageNb: number, pageSize: number): Promise<GetItemsListResponse> {
    return await this.orderApiClient.GetItemsList(pageNb, pageSize);
  }
  async GetItemsListByWorkflowAccessLevel(
    pageNb: number,
    pageSize: number,
    workflowAccessLevel: AclWorkflowAccessLevel
  ): Promise<GetItemsListResponse> {
    return await this.orderApiClient.GetItemsListByWorkflowAccessLevel(pageNb, pageSize, workflowAccessLevel);
  }
  async GetItemsListByDate(startDateAsString: string, endDateAsString: string): Promise<GetItemsListResponse> {
    return await this.orderApiClient.GetItemsListByDate(startDateAsString, endDateAsString);
  }
  async GetItemsListQuoteByDate(startDateAsString: string, endDateAsString: string): Promise<GetItemsListResponse> {
    return await this.orderApiClient.GetItemsListQuoteByDate(startDateAsString, endDateAsString);
  }
  async GetItemsListByDateAndWorkflowAccessLevel(
    startDateAsString: string,
    endDateAsString: string,
    workflowAccessLevel: AclWorkflowAccessLevel
  ): Promise<GetItemsListResponse> {
    return await this.orderApiClient.GetItemsListByDateAndWorkflowAccessLevel(
      startDateAsString,
      endDateAsString,
      workflowAccessLevel
    );
  }
  async GetOrdersItemsListByTitleId(titleId: number, pageNb: number, pageSize: number): Promise<AdminTitleOrderRow[]> {
    const response = await this.orderApiClient.GetOrdersItemsListByTitleId(titleId, pageNb, pageSize);
    if (response === null) return [];
    let output: AdminTitleOrderRow[] = [];
    response?.items.forEach((order) => {
      output.push({
        id: order.id,
        orderId: order.orderId!,
        creationDate: order.creationTime,
        owner: order.ownerUserName,
        customerName: order.customerName,
        comments: order.message,
        status: order.status,
        type: order.type,
        dueDate: order.dueDate,
        summarizedInfos: order.summarizedInfos,
        ownerUserGroupName: order.ownerUserGroupName,
        startTime: order.startTime,
        endTime: order.endTime,
      });
    });
    return output;
  }
  async GetOrdersItemsListByAssetId(titleId: number, pageNb: number, pageSize: number): Promise<AdminTitleOrderRow[]> {
    const response = await this.orderApiClient.GetOrdersItemsListByAssetId(titleId, pageNb, pageSize);
    if (response === null) return [];
    let output: AdminTitleOrderRow[] = [];
    response?.items.forEach((order) => {
      output.push({
        id: order.id,
        orderId: order.orderId!,
        creationDate: order.creationTime,
        owner: order.ownerUserName,
        customerName: order.customerName,
        comments: order.message,
        status: order.status,
        type: order.type,
        dueDate: order.dueDate,
        summarizedInfos: order.summarizedInfos,
        ownerUserGroupName: order.ownerUserGroupName,
        startTime: order.startTime,
        endTime: order.endTime,
      });
    });
    return output;
  }
  async GetOrderItem(itemId: number): Promise<GetOrderItemResponse> {
    return await this.orderApiClient.GetOrderItem(itemId);
  }
  async GetOrderItemStack(itemId: number): Promise<GetOrderItemStackResponse> {
    return await this.orderApiClient.GetOrderItemStack(itemId);
  }
  async GetOrderItemManualTasks(itemId: number): Promise<GetOrderItemManualTasksResponse> {
    return await this.orderApiClient.GetOrderItemManualTasks(itemId);
  }
  async PlayOrderItemById(itemId: number): Promise<GenericResponseStd> {
    return await this.orderApiClient.PlayOrderItemById(itemId);
  }
  async SendInvoiceAck(itemId: number): Promise<GenericResponseStd> {
    return await this.orderApiClient.SendInvoiceAck(itemId);
  }
  async CancelOrderItemById(itemId: number): Promise<GenericResponseStd> {
    return await this.orderApiClient.CancelOrderItemById(itemId);
  }
  async RetryOrderItemById(itemId: number): Promise<GenericResponseStd> {
    return await this.orderApiClient.RetryOrderItemById(itemId);
  }
  async RetryFromScratchOrderItemById(itemId: number): Promise<GenericResponseStd> {
    return await this.orderApiClient.RetryFromScratchOrderItemById(itemId);
  }
  async SetPriorityOnOrderItemById(itemId: number, priority: number): Promise<GenericResponseStd> {
    return await this.orderApiClient.SetPriorityOnOrderItemById(itemId, priority);
  }
  async ApplyManualChangesOnItemById(request: ApplyManualChangesOnItemByIdRequest): Promise<GenericResponseStd> {
    return await this.orderApiClient.ApplyManualChangesOnItemById(request);
  }
  async ApplyManualChangesOnItemByIds(
    request: ApplyManualChangesOnItemByIdsRequest
  ): Promise<ApplyManualChangesOnItemByIdsResponse> {
    return await this.orderApiClient.ApplyManualChangesOnItemByIds(request);
  }
  async ModifyOrderItem(itemId: number): Promise<GenericResponseStd> {
    return await this.orderApiClient.ModifyOrderItem(itemId);
  }
  async CopyOrderItemToBasket(itemId: number): Promise<GenericResponseStd> {
    return await this.orderApiClient.CopyOrderItemToBasket(itemId);
  }
  async AssignColorToOrderItem(itemId: number, hexa: string): Promise<GenericResponseStd> {
    return await this.orderApiClient.AssignColorToOrderItem(itemId, hexa);
  }
  async SetOrderItemFollowers(request: SetOrderItemFollowersRequest): Promise<GenericResponseStd> {
    return await this.orderApiClient.SetOrderItemFollowers(request);
  }
  async RemoveIssueFromOrderItem(itemId: number, issueId: number): Promise<GenericResponseStd> {
    return await this.orderApiClient.RemoveIssueFromOrderItem(itemId, issueId);
  }
  async GetOrderItemIssueTypes(productType: string): Promise<GetOrderItemIssueTypesResponse> {
    return await this.orderApiClient.GetOrderItemIssueTypes(productType);
  }
  async GetIssuesByOrderItemId(itemId: number): Promise<GetOrderItemIssuesResponse> {
    return await this.orderApiClient.GetIssuesByOrderItemId(itemId);
  }
  async RenderNotification(itemId: number, authKey: string): Promise<ContentResult> {
    return await this.orderApiClient.RenderNotification(itemId, authKey);
  }
  async GetMissingAssetsCandidatesByTitleId(titleId: number): Promise<GetMissingAssetsByTitleId> {
    return await this.orderApiClient.GetMissingAssetsCandidatesByTitleId(titleId);
  }
  async GetBenefitsTypes(): Promise<GetBenefitsTypesResponse> {
    return await this.orderApiClient.GetBenefitsTypes();
  }
  async CreateInternalOrder(request: CreateInternalOrderRequest): Promise<GenericResponseStd> {
    return await this.orderApiClient.CreateInternalOrder(request);
  }
  async CreateQuoteRequestOrder(request: CreateQuoteOrderRequest): Promise<GenericResponseStd> {
    return await this.orderApiClient.CreateQuoteRequestOrder(request);
  }
  async CreateSimpleOrdder(request: CreateSimpleOrderRequest): Promise<GenericResponseStd> {
    return await this.orderApiClient.CreateSimpleOrder(request);
  }
  async GetMetadataFields(): Promise<GetMetadataFieldsListResponse> {
    return await this.orderApiClient.GetMetadataFields();
  }
  async GetCurrencies(): Promise<GetCurrenciesResponse> {
    return await this.orderApiClient.GetCurrencies();
  }
  async GetPriceRules(): Promise<GetPriceRulesResponse> {
    return await this.orderApiClient.GetPriceRules();
  }
  async CreatePriceRule(priceRule: DbOrderPriceRuleInfos): Promise<GenericResponseStd> {
    return await this.orderApiClient.CreatePriceRule(priceRule);
  }
  async UpdatePriceRule(priceRule: DbOrderPriceRuleInfos): Promise<GenericResponseStd> {
    return await this.orderApiClient.UpdatePriceRule(priceRule);
  }
  async DeletePriceRule(id: number): Promise<GenericResponseStd> {
    return await this.orderApiClient.DeletePriceRule(id);
  }
  async MatchPriceRule(request: MatchPriceRuleRequest): Promise<GetPriceRulesResponse> {
    return await this.orderApiClient.MatchPriceRule(request);
  }
  async GetWatermarks(pageNumber: number, pageSize: number): Promise<GetWatermarksResponse> {
    return await this.orderApiClient.GetWatermarks(pageNumber, pageSize);
  }
  async GetWatermarksByDate(startDate: string, endDate: string): Promise<GetWatermarksResponse> {
    return await this.orderApiClient.GetWatermarksByDate(startDate, endDate);
  }
  async GetWatermarkByKey(key: number): Promise<GetWatermarkResponse> {
    return await this.orderApiClient.GetWatermarkByKey(key);
  }
  async ResendTransferEmail(request: ResendTransferEmailRequest): Promise<GenericResponseStd> {
    return await this.orderApiClient.ResendTransferEmail(request);
  }

  //------Utils------
  GetServiceUrl(): string {
    return this.orderApiClient.GetApiUrl();
  }
}
